export const LOGIN_RESPONSE_STATUS = {
  VALID: "Valid Credentials",
  INVALID: "Invalid username or password",
};
